module.exports = __webpack_public_path__ + "static/media/why-2.ae24ad21.svg";